module.exports = __webpack_public_path__ + "img/4-3.fb2742f9.png";